import React from 'react'
import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { useSecurityContext } from '../Navigation/SecurityContext'

export function FreightIndex() {
  const location = useLocation()
  const { scopes } = useSecurityContext()

  // Only redirect to launchpad if we're at the root freight path
  if (location.pathname === '/freight' && !scopes.is_carrier) {
    return <Navigate to='launchpad' replace />
  }
  if (location.pathname === '/freight' && scopes.is_carrier) {
    return <Navigate to='invoices' replace />
  }

  return <Outlet />
}

export function InvoicesIndex() {
  return <Outlet />
}
